export const LANGS = ['es', 'en'];
export const DEFAULT_LANG = 'es';
export function isLang(value) {
    return typeof value === 'string' && LANGS.includes(value);
}
/** Construye un texto en todos los idiomas a partir de como se dice en cada uno. */
export function localize(say) {
    return Object.fromEntries(LANGS.map((lang) => [lang, say(lang)]));
}
//# sourceMappingURL=lang.js.map